import { IMetaData } from "app/types";


export interface IRelationDropdownTicket { 
  _id: string;
  ticketID: string;
  ticketName: string;
  type: string;
}


export enum TicketRelationTypeQuery {
  BLOCKED_BY = "blocked_by",
  BLOCKS = "blocks",
  DUPLICATED = "duplicated",
  PARENT = "parent",
  CHILD = "child",
  LINKED_TICKET = "linked_ticket",
}

export enum TicketRelationSortBy {
  RELATION_TYPE = "relationType",
  TICKET_NAME = "ticketName",
}

export enum TicketRelationSortOrder {
  ASC = "asc",
  DESC = "desc",
}

export interface ITicketRelationListItem {
  _id: string;
  relationType: string;
  sourceTicketId: string;
  relatedTicketId: string;
}

export interface ListTicketRelationsApiResponse {
  statusCode: number;
  message: string | Record<string, string>;
  _metadata: IMetaData;
  data: ITicketRelationListItem[];
}

export interface CreateTicketRelationApiResponse {
  statusCode: number;
  message: string | Record<string, string>;
  _metadata: IMetaData;
  data: ITicketRelationListItem;
}

export interface AvailableTicketIdsApiResponse {
  statusCode: number;
  message: string | Record<string, string>;
  _metadata: IMetaData;
  data: string[];
}

export interface ListTicketsApiResponse {
  statusCode: number;
  message: string | Record<string, string>;
  _metadata: IMetaData;
  data: IRelationDropdownTicket[];
}

export interface TicketRelationCounts {
  blockedBy?: number;
  blocks?: number;
  duplicated?: number;
  parent?: number;
  child?: number;
  linkedTicket?: number;
}

export interface TicketRelationCountsApiResponse {
  statusCode: number;
  message: string | Record<string, string>;
  _metadata: IMetaData;
  data: TicketRelationCounts;
}

export interface TicketRelationsTabState {
  relationsList: {
    loading: boolean;
    list: ITicketRelationListItem[];
    sortBy: TicketRelationSortBy;
    sortOrder: TicketRelationSortOrder;
  };
  relatedTickets: IRelationDropdownTicket[];
  detailsRelationsByType: {
    loading: boolean;
    relatedTickets: IRelationDropdownTicket[];
  };
  availableTickets: {
    loading: boolean;
    list: IRelationDropdownTicket[];
    relationType: TicketRelationTypeQuery | null;
  };
  relationCounts: TicketRelationCounts;
  createRelationLoading: boolean;
  deleteRelationLoading: boolean;
}
